
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Comment lire et comprendre vos statistiques dans le gestionnaire de publicités Meta",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Apprenez à lire et interpréter vos statistiques dans le gestionnaire de publicités Meta pour optimiser vos campagnes, ajuster vos budgets et booster vos performances.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Comment lire et comprendre vos statistiques dans le gestionnaire de publicités Meta",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Apprenez à lire et interpréter vos statistiques dans le gestionnaire de publicités Meta pour optimiser vos campagnes, ajuster vos budgets et booster vos performances.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
